var map = {
	"./1677512338458-Kariuki_Ngari.jpg": 331,
	"./Abdi Mohamed.jpg": 332,
	"./Abhishek.jpg": 333,
	"./BAK.png": 334,
	"./Bamisebi.jpg": 335,
	"./Barclays.png": 336,
	"./Bonaventure.jpg": 337,
	"./Chresta.jpg": 338,
	"./Cogebanque.jpg": 339,
	"./Copenhegan.png": 340,
	"./Daniel Murage.jpeg": 341,
	"./Daniel.jpg": 342,
	"./Ecobank.png": 343,
	"./Equity.png": 344,
	"./Erdal.jpg": 345,
	"./Faheem.jpg": 346,
	"./FirstBank.png": 347,
	"./Francis Mumbi.jpg": 348,
	"./HABITAT.png": 349,
	"./Harrison.jpg": 350,
	"./ISACA.jpg": 351,
	"./Ian Collins.jpeg": 352,
	"./Jaochim.jpeg": 353,
	"./Julius Orayo.jpg": 354,
	"./KENYA.png": 355,
	"./KRA.png": 356,
	"./Karanja Gichiri.jpg": 357,
	"./Kevin Mwandau.jpeg": 358,
	"./Lanre.png": 359,
	"./Lguru.jpg": 360,
	"./MG.png": 361,
	"./MIGORI.png": 362,
	"./Michael michie.jpeg": 363,
	"./Michael.jpg": 364,
	"./NTSA.png": 365,
	"./Patricia.jpg": 366,
	"./PeteN.jpg": 367,
	"./Peter.jpg": 368,
	"./PureSoftware Logo.png": 369,
	"./RI.png": 370,
	"./Raoul.jpg": 371,
	"./Roland Headshot.jpeg": 372,
	"./SC.png": 373,
	"./SOCIETE.png": 374,
	"./Sahil Arya.jpeg": 375,
	"./Shekar Murthy.png": 376,
	"./Speaker - Gunjan Dhingra.jpeg": 377,
	"./Stella.jpg": 378,
	"./Stephen Kagaruki.jpg": 379,
	"./Steve.jpg": 380,
	"./Thomas2.jpg": 381,
	"./UAP.png": 382,
	"./UASIN.jpg": 383,
	"./UBE.jpg": 384,
	"./Unity.png": 385,
	"./Varghese.jpg": 386,
	"./Wole.jpg": 387,
	"./Yellow.ai ( Logo)  (1).jpg": 388,
	"./abeed.jpg": 389,
	"./absa.png": 390,
	"./abyssinia.jpg": 391,
	"./access.png": 392,
	"./aijaz.jpg": 393,
	"./amrit.png": 394,
	"./atlas.png": 395,
	"./azentio.jpeg": 396,
	"./azentio.jpg.sb-3a783778-Jn0SEv": 397,
	"./azentio.png": 398,
	"./backbase.jpeg": 399,
	"./bancABC.jpg": 400,
	"./bankingReports.png": 401,
	"./baseer.jpg": 402,
	"./bk.jpg": 403,
	"./cbok.png": 404,
	"./chike.jpg": 405,
	"./christian.jpg": 406,
	"./citi.jpeg": 407,
	"./coop.jpg": 408,
	"./cornel.png": 409,
	"./crdb.png": 410,
	"./david.jpeg": 411,
	"./deogratius.jpg": 412,
	"./dtb.png": 413,
	"./euity.png": 414,
	"./fbc.png": 415,
	"./gfb.jpeg": 416,
	"./hartnell.jpg": 417,
	"./henry.jpg": 418,
	"./imb.png": 419,
	"./kcb.png": 420,
	"./kevin.jpg": 421,
	"./koroty.png": 422,
	"./lance.jpg": 423,
	"./melaku.png": 424,
	"./microsoft.png": 425,
	"./musoni.png": 426,
	"./mutisunge.jpg": 427,
	"./nbc.png": 428,
	"./nbe.jpeg": 429,
	"./ncba.png": 430,
	"./neal.jpg": 431,
	"./nmb.jpg": 432,
	"./novacom.jpg": 433,
	"./olanma.jpg": 434,
	"./paytm.jpg": 435,
	"./pure.jpeg": 436,
	"./raymond.jpg": 437,
	"./rohit.jpg": 438,
	"./sagna.jpg": 439,
	"./sbm1.png": 440,
	"./simon.jpg": 441,
	"./smartstream.jpeg": 442,
	"./speaker.jpg": 35,
	"./speaker.png": 52,
	"./st.png": 443,
	"./stanley.jpg": 444,
	"./stephane.jpg": 445,
	"./sulaiman.jpg": 446,
	"./supriyo.jpg": 447,
	"./tejal.png": 448,
	"./test.jpg": 449,
	"./thomas.jpg": 450,
	"./uba.jpeg": 451,
	"./victor.png": 452,
	"./walubita.jpg": 453,
	"./wane.jpg": 454,
	"./yared.jpg": 455,
	"./yellow.jpeg": 456,
	"./zanaco.jpg": 457
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78;